import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CloseRounded } from "@mui/icons-material";
import { Avatar, Dialog, DialogContent, Divider, FormControl, Grid, InputLabel, Menu, MenuItem, Select, TextField, Typography } from "@mui/material";
import { api_urls } from "../../../utils/api-urls/index.js";
import * as CategoryActions from '../../../redux/actions/categoryAction.js';
import * as SubCategoryActions from '../../../redux/actions/subCategoryAction.js';
import * as YatraActions from '../../../redux/actions/yatraAction.js';
import MainDatatable from "../../../components/common/MainDatatable.jsx";
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { AddSvg, CrossSvg, DeleteSvg, EditSvg, FilterSvg, SwitchOffSvg, SwitchOnSvg, ViewSvg } from "../../../assets/svg/index.js";
import { RedirectPageData } from "../../../utils/static-data/index.js";

const DisplayPackage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { categoryData } = useSelector(state => state.categoryReducer);
  const { subCatgeoryDataByCategoryId } = useSelector(state => state.subCategoryReducer);

  const { yatraData: yatraPackageData } = useSelector(state => state.yatraReducer);

  const redirectCategoryData = categoryData.filter(value => value?.redirect_page === 'Yatra');   //* Redirect Category Data For Category Name Option

  const [modalVisible, setModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [yatraPackageDetail, setYatraPackageDetail] = useState({ yatraPackageId: '', subCategoryId: '', categoryId: '', yatraPackageName: '', yatraPackagePrice: '', yatraPackageDescription: '', yatraType: '' });
  const [inputFieldError, setInputFieldError] = useState({ categoryId: '', subCategoryId: '', yatraPackageName: '', yatraPackagePrice: '', yatraPackageImage: '', yatraPackageDescription: '', yatraType: '' });
  const [yatraPackageImage, setYatraPackageImage] = useState({ file: logo_icon, bytes: "" });
  const [includedBullet, setIncludedBullet] = useState(['']);
  const [notIncludedBullet, setNotIncludedBullet] = useState(['']);

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setYatraPackageDetail({ ...yatraPackageDetail, [name]: value });
  };

  //* Handle Yatra Package Image
  const handleYatraPackageImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setYatraPackageImage({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }

    handleInputFieldError("yatraPackageImage", null)
  };

  //! Handle Edit - Yatra Package
  const handleEdit = (data) => {
    setModalVisible(!modalVisible)
    console.log("Edit Data ::: ", data)

    setYatraPackageDetail({
      yatraPackageId: data?._id || '',
      categoryId: data?.categoryId?._id || '',
      subCategoryId: data?.subCategoryId?._id || '',
      yatraPackageName: data?.title || '',
      yatraPackageDescription: data?.description || '',
      yatraPackagePrice: data?.price || '',
      yatraType: data?.yatra_type || '',
    });
    setIncludedBullet(data?.included?.split(","))
    setNotIncludedBullet(data?.not_included?.split(","))
    setYatraPackageImage({ file: api_urls + data?.image || logo_icon })
  }

  //! Handle View - Single Yatra Package
  const handleView = (data) => {
    console.log("View Data ::: ", data)
    setViewModalVisible(true)
    setViewModalData(data)

    setYatraPackageDetail(data)

    // setYatraPackageDetail({
    //   yatraPackageId: data?._id || '',
    //   categoryId: data?.categoryId?._id || '',
    //   yatraPackageName: data?.title || '',
    //   yatraPackageDescription: data?.description || '',
    //   yatraPackagePrice: data?.price || '',
    // });
    // setIncludedBullet(data?.included?.split(","))
    // setNotIncludedBullet(data?.not_included?.split(","))
    // setYatraPackageImage({ file: api_urls + data?.image || logo_icon })
  }

  //* Bullet Start
  const handleIncludedBulletChange = (index, e) => {
    const newBullet = [...includedBullet];
    newBullet[index] = e.target.value;
    setIncludedBullet(newBullet);
  };

  const handleAddIncludedBulletField = () => {
    setIncludedBullet([...includedBullet, '']);
  };

  const handleRemoveIncludedBulletField = (index) => {
    const newBullet = [...includedBullet];
    index !== 0 && newBullet.splice(index, 1);
    setIncludedBullet(newBullet);
  };

  // ============== 

  const handleNotIncludedBulletChange = (index, e) => {
    const newBullet = [...notIncludedBullet];
    newBullet[index] = e.target.value;
    setNotIncludedBullet(newBullet);
  };

  const handleAddNotIncludedBulletField = () => {
    setNotIncludedBullet([...notIncludedBullet, '']);
  };

  const handleRemoveNotIncludedBulletField = (index) => {
    const newBullet = [...notIncludedBullet];
    index !== 0 && newBullet.splice(index, 1);
    setNotIncludedBullet(newBullet);
  };
  //* Bullet End

  //! Handle Validation
  const handleValidation = () => {
    let isValid = true;
    const { redirectPage, yatraPackageName, status, categoryId } = yatraPackageDetail;
    const { bytes } = yatraPackageImage;

    if (!redirectPage) {
      handleInputFieldError("redirectPage", "Please Select Redirect Page")
      isValid = false;
    }
    if (!categoryId) {
      handleInputFieldError("categoryId", "Please Select Category Name")
      isValid = false;
    }
    if (!yatraPackageName) {
      handleInputFieldError("yatraPackageName", "Please Enter Yatra Package Name")
      isValid = false;
    }
    if (!bytes) {
      handleInputFieldError("yatraPackageImage", "Please Select Image")
      isValid = false;
    }
    if (!status) {
      handleInputFieldError("status", "Please Select Status")
      isValid = false;
    }
    return isValid;
  };

  //! Handle Submit - Updating Yatra Package
  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (handleValidation()) {
    console.log("Yatra Package Data :: ", { ...yatraPackageDetail, yatraPackageImage, includedBullet, notIncludedBullet })
    const { yatraPackageId, categoryId, subCategoryId, yatraPackageName, yatraPackagePrice, yatraPackageDescription, yatraType } = yatraPackageDetail;

    let formData = new FormData()
    formData.append("yatraId", yatraPackageId)
    formData.append("categoryId", categoryId)
    formData.append("subCategoryId", subCategoryId)
    formData.append("title", yatraPackageName)
    formData.append("price", yatraPackagePrice)
    formData.append("description", yatraPackageDescription)
    formData.append("included", includedBullet)
    formData.append("not_included", notIncludedBullet)
    formData.append("yatra_type", yatraType)
    formData.append("image", yatraPackageImage?.bytes);

    const payload = {
      data: formData,
      onComplete: () => setModalVisible(false)
    }

    //! Dispatching API for Updating Category
    dispatch(YatraActions.updateYatra(payload))
    // }
  };

  //! Handle Filter 
  const [filterText, setfilterText] = useState('');
  const uniqueRedirectPage = Array.from(new Set(yatraPackageData.map(item => item.redirectPage)));
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpenFilterDropDown = (event) => { setAnchorEl(event.currentTarget) };
  const handleCloseFilterDropDown = () => { setAnchorEl(null) };

  const handleFilter = (data) => {
    setfilterText(data)
    handleCloseFilterDropDown()
  };

  let filteredData;
  if (filterText.toLowerCase() === "all") {
    filteredData = yatraPackageData;
  } else {
    filteredData = yatraPackageData && yatraPackageData.filter(item =>
      Object.values(item).some(value =>
        value && value?.toString().toLowerCase().includes(filterText?.toLowerCase())
      )
    );
  }

  //* Yatra Package DataTable Columns
  const yatraPackageColumns = [
    { name: 'S.No.', selector: row => filteredData.length - filteredData.indexOf(row), width: '70px' },
    { name: 'Category', selector: row => row?.categoryId?.category_name },
    { name: 'Sub Category', selector: row => row?.subCategoryId?.sub_category_name },
    { name: 'Child Category', selector: row => row?.childCategoryId?.child_category_name || '-' },
    { name: 'Package Name', selector: row => row?.title },
    { name: 'Price', selector: row => row?.price },
    // { name: <div onClick={handleOpenFilterDropDown} style={{ cursor: "pointer", display: "flex", alignItems: "center" }}><span>Redirect Page</span>  <FilterSvg h={'16'} /></div>, selector: row => row?.redirectPage },
    { name: 'Image', cell: row => <img src={row?.image ? api_urls + row?.image : logo_icon} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
    { name: 'Status', selector: row => <div onClick={() => dispatch(YatraActions?.changeYatraStatus({ yatraId: row?._id }))} style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
    {
      name: 'Action',
      cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
        <div onClick={() => handleView(row)} style={{ cursor: "pointer" }}><ViewSvg /></div>
        <div onClick={() => handleEdit(row)} style={{ cursor: "pointer" }}><EditSvg /></div>
        <div onClick={() => dispatch(YatraActions.deleteYatra({ yatraId: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
      </div>,
      width: "180px"
    },
  ]

  useEffect(() => {
    //! Dispatching API for Getting Yatra
    dispatch(YatraActions.getYatra())

    //! Dispatching API for Getting Category
    dispatch(CategoryActions.getCategory())
  }, []);

  useEffect(() => {
    //! Dispatching API for Getting Sub Category
    yatraPackageDetail?.categoryId && dispatch(SubCategoryActions.getSubCategoryByCategoryId({ categoryId: yatraPackageDetail?.categoryId }))
  }, [yatraPackageDetail?.categoryId]);

  return (
    <>
      <MainDatatable data={filteredData} columns={yatraPackageColumns} title={'Yatra Package'} url={'/add-yatra'} />

      {/* Edit Modal */}
      <Dialog
        open={modalVisible}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ fontSize: "23px", fontWeight: "600" }}>Edit Yatra Package</div>
                <div style={{ cursor: "pointer" }} onClick={() => setModalVisible(false)}><CloseRounded /></div>
              </div>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <FormControl fullWidth>
                <InputLabel id="select-label">Select Category Name</InputLabel>
                <Select
                  label="Select Category Name" variant="outlined" fullWidth
                  name='categoryId'
                  value={yatraPackageDetail?.categoryId}
                  onChange={handleInputField}
                  error={inputFieldError?.categoryId ? true : false}
                  onFocus={() => handleInputFieldError("categoryId", null)}
                >
                  <MenuItem disabled>---Select Category Name---</MenuItem>
                  {redirectCategoryData.map((value, index) => {
                    return <MenuItem key={index} value={value?._id}>{value?.category_name}</MenuItem>
                  })}
                </Select>
              </FormControl>
              {inputFieldError?.categoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.categoryId}</div>}
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <FormControl fullWidth>
                <InputLabel id="select-label">Select Sub Category</InputLabel>
                <Select
                  label="Select Sub Category" variant="outlined" fullWidth
                  name='subCategoryId'
                  value={yatraPackageDetail?.subCategoryId}
                  onChange={handleInputField}
                  error={inputFieldError?.subCategoryId ? true : false}
                  onFocus={() => handleInputFieldError("subCategoryId", null)}
                >
                  {subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>---Please First Select category---</MenuItem> : <MenuItem disabled>---Select Sub Category---</MenuItem>}
                  {subCatgeoryDataByCategoryId && subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>You don't have Sub category</MenuItem> : subCatgeoryDataByCategoryId?.map(value => (<MenuItem key={value?._id} value={value?._id}>{value?.sub_category_name}</MenuItem>))}
                </Select>
              </FormControl>
              {inputFieldError?.subCategoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.subCategoryId}</div>}
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <TextField
                label="Yatra Package Name" variant='outlined' fullWidth
                name='yatraPackageName'
                value={yatraPackageDetail?.yatraPackageName}
                onChange={handleInputField}
                error={inputFieldError.yatraPackageName ? true : false}
                helperText={inputFieldError.yatraPackageName}
                onFocus={() => handleInputFieldError("yatraPackageName", null)}
              />
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <TextField
                label="Yatra Price" variant='outlined' fullWidth
                name='yatraPackagePrice'
                value={yatraPackageDetail?.yatraPackagePrice}
                onChange={handleInputField}
                error={inputFieldError.yatraPackagePrice ? true : false}
                helperText={inputFieldError.yatraPackagePrice}
                onFocus={() => handleInputFieldError("yatraPackagePrice", null)}
              />
            </Grid>

            <Grid item lg={6} sm={6} md={12} xs={12} >
              <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
                <Grid item xs={2} >
                  <Avatar src={yatraPackageImage.file} style={{ width: 40, height: 40 }} />
                </Grid>
                <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                  Upload Yatra Package Image
                  <input onChange={handleYatraPackageImage} hidden accept="image/*" type="file" />
                </Grid>
              </Grid>
              {inputFieldError?.yatraPackageImage && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.yatraPackageImage}</div>}
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12} >
              <FormControl fullWidth>
                <InputLabel id="select-label">Select Type</InputLabel>
                <Select
                  label="Select Type" variant="outlined" fullWidth
                  name='yatraType'
                  value={yatraPackageDetail?.yatraType}
                  onChange={handleInputField}
                  error={inputFieldError.yatraType ? true : false}
                  onFocus={() => handleInputFieldError("yatraType", null)}
                >
                  <MenuItem disabled>---Select Yatra Type---</MenuItem>
                  <MenuItem value="Basic">Basic</MenuItem>
                  <MenuItem value="Premium">Premium</MenuItem>
                </Select>
              </FormControl>
              {inputFieldError?.yatraType && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.yatraType}</div>}
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container sx={{ alignItems: "center" }} spacing={3}>
                {includedBullet.map((bullet, index) => (
                  <Grid item lg={6} md={6} sm={12} xs={12} key={index}>
                    <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                      <TextField
                        label={`Included Bullet ${index + 1}`}
                        variant="outlined"
                        fullWidth
                        value={bullet}
                        onChange={(e) => handleIncludedBulletChange(index, e)}
                      />
                      <div style={{ cursor: 'pointer', color: index == 0 ? 'grey' : 'red', position: "absolute", right: "10px" }} onClick={() => handleRemoveIncludedBulletField(index)} >
                        <CrossSvg w={'20'} />
                      </div>
                      {index === 0 && <div style={{ cursor: 'pointer', color: 'green', position: "absolute", right: "30px" }} onClick={() => handleAddIncludedBulletField()} >
                        <AddSvg w={'24'} />
                      </div>}
                    </div>
                  </Grid>
                ))}
                {notIncludedBullet.map((bullet, index) => (
                  <Grid item lg={6} md={6} sm={12} xs={12} key={index}>
                    <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                      <TextField
                        label={`Not Included Bullet ${index + 1}`}
                        variant="outlined"
                        fullWidth
                        value={bullet}
                        onChange={(e) => handleNotIncludedBulletChange(index, e)}
                      />
                      <div style={{ cursor: 'pointer', color: index == 0 ? 'grey' : 'red', position: "absolute", right: "10px" }} onClick={() => handleRemoveNotIncludedBulletField(index)} >
                        <CrossSvg w={'20'} />
                      </div>
                      {index === 0 && <div style={{ cursor: 'pointer', color: 'green', position: "absolute", right: "30px" }} onClick={() => handleAddNotIncludedBulletField()} >
                        <AddSvg w={'24'} />
                      </div>}
                    </div>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12} >
              <TextField
                label="Yatra Package Description" variant='outlined' fullWidth
                name='yatraPackageDescription'
                value={yatraPackageDetail?.yatraPackageDescription}
                onChange={handleInputField}
                error={inputFieldError.yatraPackageDescription ? true : false}
                helperText={inputFieldError.yatraPackageDescription}
                onFocus={() => handleInputFieldError("yatraPackageDescription", null)}
              />
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginTop: "15px" }}>
              <Grid container spacing={2}>
                <Grid item lg={6} sm={6} md={6} xs={6} >
                  <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px", textAlign: "center", fontFamily: "Philosopher" }}>Submit</div>
                </Grid>
                <Grid item lg={6} sm={6} md={6} xs={6} >
                  <div onClick={() => setModalVisible(false)} style={{ fontWeight: "500", backgroundColor: "#EDF2F5", color: "#000", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px", textAlign: "center", fontFamily: "Philosopher" }}>
                    Close
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* View Modal */}
      <Dialog
        open={viewModalVisible}>
        <DialogContent>
          <Grid container spacing={2} sx={{ fontSize: "14px" }}>
            <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginBottom: "20px" }}>
              <div style={{ display: "flex", alignItems: "flex-end", gap: "20px", justifyContent: "space-between" }}>
                <div style={{ fontSize: "23px", fontWeight: "600" }}>View Yatra Package</div>
                <div style={{ cursor: "pointer" }} onClick={() => setViewModalVisible(false)}><CloseRounded /></div>
              </div>
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12}>
              <Grid container spacing={3} sx={{ alignItems: "center" }}>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <Avatar src={api_urls + yatraPackageDetail?.image} alt={yatraPackageDetail?.title} style={{ width: "150px", height: "130px", borderRadius: "initial" }} />
                </Grid>

                <Grid item lg={8} md={9} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div>Title: {yatraPackageDetail?.title}</div>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div>Category: {yatraPackageDetail?.categoryId?.category_name}</div>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div>Sub Category: {yatraPackageDetail?.subCategoryId?.sub_category_name}</div>
                      <div>Child Category: {yatraPackageDetail?.childCategoryId?.child_category_name || '-'}</div>
                    </Grid>
                    <Grid item lg={12} sm={12} md={12} xs={12}>
                      <div>Price: {yatraPackageDetail?.price}</div>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div>Plan Type: {yatraPackageDetail?.yatra_type}</div>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div>Status: {yatraPackageDetail?.status}</div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div>Description: {yatraPackageDetail?.description}</div>
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12}>
              <div style={{ marginBottom: "10px" }}>Included Points: </div>
              <ul style={{ display: "flex", flexDirection: "column", gap: "5px", padding: "0 10px" }}>{yatraPackageDetail?.included?.split(",")?.map((value, index) => (<li key={index}>{value}</li>))}</ul>
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12}>
              <div style={{ marginBottom: "10px" }}>Not Included Points: </div>
              <ul style={{ display: "flex", flexDirection: "column", gap: "5px", padding: "0 10px" }}>{yatraPackageDetail?.not_included?.split(",")?.map((value, index) => (<li key={index}>{value}</li>))}</ul>
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12} sx={{ marginTop: "15px" }}>
              <Grid container spacing={2}>
                <Grid item lg={6} sm={6} md={6} xs={6} >
                  <div onClick={() => setViewModalVisible(false)} style={{ fontWeight: "500", backgroundColor: "#EDF2F5", color: "#000", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px", textAlign: "center", fontFamily: "Philosopher" }}>
                    Close
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseFilterDropDown} >
        <MenuItem style={{ width: "100px" }} onClick={() => handleFilter('all')}>All</MenuItem>
        {uniqueRedirectPage?.map((value, index) => (
          <MenuItem key={index} style={{ width: "100px" }} onClick={() => handleFilter(value)}>{value}</MenuItem>
        ))}
      </Menu>
    </ >
  );
}

export default DisplayPackage;